import { SeoHead } from "@/components/SeoHead";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="私隱政策"
        description="了解 Skoltend 如何根據香港《個人資料（私隱）條例》收集、使用及保護您在使用本平台時所提供的個人資料。"
        canonical="/privacy"
      />
      <div className="border-b bg-secondary/30 py-8">
        <div className="container mx-auto px-4 md:px-8 max-w-3xl">
          <h1 className="text-2xl font-bold mb-1">私隱政策</h1>
          <p className="text-muted-foreground text-sm">最後更新：2025 年 5 月</p>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-8 py-10 max-w-3xl space-y-8 text-sm leading-relaxed text-foreground">

        <section className="space-y-3">
          <h2 className="text-base font-semibold">1. 概覽</h2>
          <p>
            Skoltend（「本平台」）由香港學校招標資訊服務提供。本私隱政策說明我們如何收集、使用及保護您在使用
            <strong> www.skoltend.com </strong>時所提供的個人資料，並符合香港《個人資料（私隱）條例》（第 486 章）之規定。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">2. 收集的資料</h2>
          <p>我們可能收集以下類別的個人資料：</p>
          <ul className="list-disc list-inside space-y-1 pl-2 text-muted-foreground">
            <li>帳戶資料：電郵地址、顯示名稱（透過 Google 登入或電郵註冊時提供）</li>
            <li>付款資料：由 Stripe 安全處理，本平台不直接儲存信用卡資料</li>
            <li>Telegram 資料：如您選擇綁定 Telegram，我們會儲存您的 Telegram 用戶 ID 及用戶名</li>
            <li>使用資料：瀏覽記錄、裝置類型、IP 地址等技術資料（用於安全及服務優化）</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">3. 使用目的</h2>
          <p>收集的個人資料僅用於以下目的：</p>
          <ul className="list-disc list-inside space-y-1 pl-2 text-muted-foreground">
            <li>提供及維護本平台的服務</li>
            <li>處理會員訂閱及付款</li>
            <li>發送您已訂閱的電郵或 Telegram 招標通知</li>
            <li>回應您的查詢及提供客戶支援</li>
            <li>改善平台功能及用戶體驗</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">4. 資料共享</h2>
          <p>
            我們不會向第三方出售您的個人資料。我們僅在以下情況下共享資料：
          </p>
          <ul className="list-disc list-inside space-y-1 pl-2 text-muted-foreground">
            <li><strong>Clerk</strong>：身份驗證服務提供商，處理登入及帳戶安全</li>
            <li><strong>Stripe</strong>：付款處理服務，處理訂閱費用</li>
            <li><strong>Resend</strong>：電郵發送服務，用於發送通知</li>
            <li><strong>Telegram</strong>：如您選擇綁定，用於發送招標通知</li>
            <li>法律要求：在法律規定的情況下，向相關主管機關披露</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">5. 資料保留</h2>
          <p>
            您的帳戶資料會在您的帳戶存續期間保留。如您取消訂閱或刪除帳戶，我們將在合理期限內刪除或匿名化您的個人資料，除非法律另有規定。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">6. 您的權利</h2>
          <p>根據香港《個人資料（私隱）條例》，您有權：</p>
          <ul className="list-disc list-inside space-y-1 pl-2 text-muted-foreground">
            <li>查閱我們持有的您的個人資料</li>
            <li>要求更正不準確的個人資料</li>
            <li>要求刪除您的個人資料（在適用情況下）</li>
            <li>拒絕接收推廣通訊</li>
          </ul>
          <p>如需行使上述權利，請透過以下方式聯絡我們。</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">7. 安全措施</h2>
          <p>
            本平台採用業界標準的安全措施保護您的個人資料，包括 HTTPS 加密傳輸、安全的資料庫存儲及訪問控制。但請注意，互聯網傳輸不能保證百分百安全。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">8. Cookie 及追蹤技術</h2>
          <p>
            本平台使用 Cookie 及類似技術維持您的登入狀態及提升瀏覽體驗。您可透過瀏覽器設定管理 Cookie，但停用 Cookie 可能影響部分功能。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">9. 私隱政策更新</h2>
          <p>
            我們可能不定期更新本私隱政策。重大變更將透過電郵或平台通知告知您。繼續使用本平台即表示您同意更新後的政策。
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-base font-semibold">10. 聯絡我們</h2>
          <p>如您對本私隱政策有任何疑問，請電郵至：</p>
          <p>
            <a href="mailto:cs@skoltend.com" className="text-primary hover:underline font-medium">
              cs@skoltend.com
            </a>
          </p>
        </section>

      </div>
    </div>
  );
}
